import React, { useState, useEffect, useMemo } from "react";
import { BrowserRouter } from "react-router-dom";
import "./App.css";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { getTheme } from "./Components/ThemeProvider/ThemeProvider";
import Router from "./routes";
import Footer from "./Components/Footer/Footer";
import BackToTopButton from "./Components/BacktoTop/BackToTopComp";
import HeaderComp from "./Components/HeaderComp/HeaderComp";
import FooterComp from "./Components/FooterComp/FooterComp";
import { useSelector } from "react-redux";
import { CssBaseline } from "@mui/material";
import { isMobile } from "react-device-detect";
import { REFERURL } from "./shared/constants";

function App() {
  const getSystemTheme = () =>
    window.matchMedia("(prefers-color-scheme: dark)").matches
      ? "dark"
      : "light";

  const [mode, setMode] = useState(getSystemTheme());

  const theme = useMemo(() => getTheme(mode), [mode]);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", mode);
  }, [mode]);

  // useEffect(() => {
  //   if (isMobile) {
  //     const referralCode = new URLSearchParams(window.location.search).get("c");
  //     const referralCodePartner: any = new URLSearchParams(
  //       window.location.search,
  //     ).get("p");
  //     const appUrl: any = new URL(`${REFERURL}`);

  //     if (referralCode) {
  //       appUrl.searchParams.set("c", referralCode);
  //     } else {
  //       appUrl.searchParams.set("p", referralCodePartner);
  //     }

  //     window.location.replace(appUrl.toString());
  //   }
  // }, []);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");

    const handleChange = (e: any) => {
      setMode(e.matches ? "dark" : "light");
    };

    mediaQuery.addEventListener("change", handleChange);

    return () => {
      mediaQuery.removeEventListener("change", handleChange);
    };
  }, []);

  const pathName = useSelector((state: any) => state.PATHNAME.pathname);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {/* <HeaderComp /> */}

      <BrowserRouter>
        <Router />
      </BrowserRouter>

      {/* {pathName === "/" && (
        <div className="webFooter">
          <FooterComp />
        </div>
      )} */}

      <BackToTopButton />
    </ThemeProvider>
  );
}

export default App;
